import { logError } from "utilities/Functions/GlobalHelperFunctions";
import { VALUE_CHAIN_API } from "utilities/AdiApi";
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";


const EventAPI = {

  getByEpc: async (epcId: string) => {
    const bizCode = getBizCode()
    try {
      const res = await VALUE_CHAIN_API.get(`valuechain_traceability/${bizCode}?EPC=${epcId}`)
      return res.data.body
    } catch (e) {
      logError(e)
      throw e
    }
  }

}

export default EventAPI